import script from "./AppImage.vue?vue&type=script&setup=true&lang=js"
export * from "./AppImage.vue?vue&type=script&setup=true&lang=js"

import "./AppImage.vue?vue&type=style&index=0&id=8a7119da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a7119da"]])

export default __exports__